export const IntercomService = () => {
	const { locale } = useI18n()
	const INTERCOM_KEY = 'ax6krwgb'

	const setupIntercomObserver = () => {
		const observer = new MutationObserver((mutations) => {
			mutations.forEach((mutation) => {
				if (mutation.addedNodes.length) {
					const intercomStore = useIntercomStore()
					const otherPosition = intercomStore.getOtherPosition
					if (otherPosition) {
						setIntercomPosition(otherPosition.bottom, otherPosition.right)
					}
				}
			})
		})

		observer.observe(document.body, {
			childList: true,
			subtree: true,
		})
	}

	const loadScript = (url: string) => {
		return new Promise<void>((resolve) => {
			const script = document.createElement('script')
			script.addEventListener('load', () => {
				resolve()
			})
			script.src = url
			document.body.appendChild(script)
		})
	}
	const bootIntercom = async () => {
		await loadScript(`https://widget.intercom.io/widget/${INTERCOM_KEY}`)
		const { Intercom } = window as any
		Intercom('shutdown')
		const intercomStore = useIntercomStore()
		const otherPosition = intercomStore.getOtherPosition
		const intercomSettings: any = {
			api_base: 'https://api-iam.eu.intercom.io',
			app_id: INTERCOM_KEY,
			language_override: locale.value === 'en' ? 'en' : 'pl',
			horizontal_padding: otherPosition?.right ? otherPosition.right : 20,
			vertical_padding: otherPosition?.bottom ? otherPosition.bottom : 20,
		}

		Intercom('boot', intercomSettings)
		setupIntercomObserver()
		Intercom('show')
	}

	const replaceFacadeWithIntercom = async () => {
		try {
			await bootIntercom()

			const intercomStore = useIntercomStore()
			intercomStore.setIsLaunched(true)
		} catch (error) {
			console.log(error)
		}
	}

	const openIntercom = async () => {
		try {
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
			// @ts-ignore
			if (!window.Intercom) await replaceFacadeWithIntercom()
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
			// @ts-ignore
			window.Intercom('show')
		} catch (error) {
			console.log(error)
		}
	}

	const shutdownIntercom = async () => {
		try {
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
			// @ts-ignore
			if (!window.Intercom) return
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
			// @ts-ignore
			await window.Intercom('shutdown')
			const intercomStore = useIntercomStore()
			intercomStore.setIsLaunched(false)
			intercomStore.setOtherPosition()
		} catch (error) {
			console.log(error)
		}
	}

	const hideIntercom = () => {
		const intercom = document.querySelector('.intercom-facade')
		const intercomReal = document.querySelector('.intercom-app')
		if (intercom) {
			intercom.style.zIndex = '-10'
		}
		if (intercomReal) {
			const secondChild = intercomReal.children[1] // Index 1 corresponds to the second child
			if (secondChild) {
				secondChild.style.zIndex = '-10'
			}
		}
	}

	const unhideIntercom = () => {
		const intercom = document.querySelector('.intercom-facade')
		const intercomReal = document.querySelector('.intercom-app')
		if (intercom) {
			intercom.style.zIndex = '900000000'
		}
		if (intercomReal) {
			const secondChild = intercomReal.children[1] // Index 1 corresponds to the second child
			if (secondChild) {
				secondChild.style.zIndex = '900000000'
			}
		}
	}

	const setIntercomPosition = async (bottom?: number, right?: number) => {
		const intercomStore = useIntercomStore()

		if (bottom || right) {
			intercomStore.setOtherPosition(bottom, right)
		} else {
			intercomStore.setOtherPosition()
		}

		await nextTick()

		const intercom = document.querySelector('.intercom-facade')
		const intercomReal = document.querySelector('.intercom-app')
		// get intercom namespace which is the second child of the intercomReal
		const intercomMessenger = intercomReal?.children[0]
		const intercomNamespace = intercomReal?.children[1]

		if (intercom) {
			intercom.style.bottom = bottom ? `${bottom}px` : '20px'
			intercom.style.right = right ? `${right}px` : '20px'
		}
		if (intercomNamespace) {
			intercomNamespace.style.transition = 'all 0.2s ease-in-out'
			intercomNamespace.style.bottom = bottom ? `${bottom}px` : '20px'
			intercomNamespace.style.right = right ? `${right}px` : '20px'
		}
		if (intercomMessenger) {
			intercomMessenger.style.bottom = bottom ? `${bottom + 68}px` : '84px'
		}
	}

	return {
		replaceFacadeWithIntercom,
		shutdownIntercom,
		openIntercom,
		hideIntercom,
		unhideIntercom,
		setIntercomPosition,
	}
}
